import classes from "./index.module.scss";

export default function Container({ children }) {
  return <div className={classes.container}>{children}</div>;
}
